import axios from 'axios';

import type {
  IUserOrgQuery,
  IUserOrgRequest,
  IUserOrgResponse,
} from '@/app-package';

const getOrgUsers = async (params?: IUserOrgQuery) => {
  const config: IUserOrgRequest = { url: '/user/org', method: 'get', params };

  const { data } = await axios.request<IUserOrgResponse>(config);

  return data;
};

export default getOrgUsers;
